export default __webpack_public_path__ + "static/media/skill2.9908584f.svg";